import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CtaSection = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/aeb44b288ccbc6d0a505012a1d885976.jpg"
          alt="Otley and surrounding areas"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#1A2F4A]/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          {/* Left - Headline */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:w-1/2 mb-8 lg:mb-0"
          >
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
              Proudly Serving<br />Otley
            </h2>
          </motion.div>

          {/* Right - Description */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:w-1/2 lg:text-right"
          >
            <p className="text-white text-xl md:text-2xl font-light mb-2">
              & surrounding areas including
            </p>
            <p className="text-white text-xl md:text-2xl font-light mb-8">
              Ilkley, Burley, Menston, Pool, and Guiseley
            </p>

            <Link
              to="/contact"
              className="inline-flex items-center space-x-3 bg-white text-[#1A2F4A] px-8 py-4 rounded-full hover:bg-gray-100 transition-all shadow-lg group whitespace-nowrap cursor-pointer"
            >
              <span className="font-semibold text-lg">See Our Service Area</span>
              <div className="w-10 h-10 flex items-center justify-center bg-[#1A2F4A] rounded-full group-hover:bg-[#2A3F5A] transition-colors">
                <i className="ri-arrow-right-line text-white text-xl"></i>
              </div>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;